export default defineNuxtRouteMiddleware((to) => {
  if (to.name !== 'd-account') {
    return
  }

  return navigateTo({ name: 'd-account-profile' })
})
